module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":{"label":"Message Template","placeholder":"Hi, I\u0027m {{name}},\\n\\ninterested to buy\\n{{product_description}}\\n\\nBuy now? Order here : {{store_link}}"}}}')
  delete Component.options._Ctor
}
